import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axiosInstance from '../../appHelpers/axiosInstance';

const DEFAULT_SOURCE = process.env.REACT_APP_TICKET_APP_SOURCE_SLUG || 'remote-site';

export function useTicketCount({ source = DEFAULT_SOURCE, siteId, systemId }) {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();
    const [count, setCount] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log('[TicketBadge] useTicketCount fired', { isAuthenticated, source, siteId, systemId });
        if (!isAuthenticated) {
            console.log('[TicketBadge] bail: not authenticated');
            setLoading(false);
            return;
        }

        if (!siteId && !systemId) {
            console.log('[TicketBadge] bail: no siteId or systemId');
            setLoading(false);
            return;
        }

        const params = new URLSearchParams({ source });
        if (siteId) params.set('site', siteId);
        if (systemId) params.set('system', systemId);

        let cancelled = false;

        (async () => {
            try {
                const token = await getAccessTokenSilently({
                    audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
                });
                const res = await axiosInstance({
                    url: `/ticket/counts?${params}`,
                    headers: { authorization: `Bearer ${token}` },
                });
                console.log('[TicketBadge] counts response', res?.data);
                if (!cancelled) setCount(res?.data);
            } catch (err) {
                console.error('[TicketBadge] fetch error', err);
                if (!cancelled) setCount(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => { cancelled = true; };
    }, [isAuthenticated, getAccessTokenSilently, source, siteId, systemId]);

    return { count, loading };
}
